export class PaidTimeOffUpdateDto {
    id: number;
    employeeId: number;
    ehiGroupId: number;
    daysUsed: number;
    month: number;
    year: number;
    updatedBy: string;
}
